import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { stacked } from 'app/shared/styles/_spacing';

export const FaqQuestion = styled.h2`
  ${font.md};
  font-weight: bold;
  ${stacked._1x};
  color: ${colors['$hpx-blue-600']};
`;

export const FaqAnswer = styled.p`
  ${font.sm};
  font-weight: normal;
  ${stacked._3x};
  color: ${colors['$hpx-grey-600']};
`;

export const FaqAnswerListHeader = styled(FaqAnswer)`
  ${stacked._1x};
  color: ${colors['$hpx-grey-600']};
`;

type FaqAnswerListProps = {
  listStyle?: 'ul' | 'ol';
};

export const FaqAnswerList = styled.ul<FaqAnswerListProps>`
  margin-left: 16px;

  ${(props) =>
    props.listStyle === 'ul' &&
    `
        list-style-type: disc;
    `}

  ${(props) =>
    props.listStyle === 'ol' &&
    `
        list-style-type: decimal;
    `}
`;

export const FaqAnswerLi = styled.li`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
`;
